// persisted data keys
export enum PersistedData {
    AwaitSocialSignIn = "awaitSocialSignIn",
    ContractsUpdated = "contractsUpdated",
    CurrentClub = "currentClub",
    DashboardToken = "dashboardToken",
    GuestIdentifier = "guestIdentifier",
    Language = "lang",
}

// get data
export const getPersistedData = (key: PersistedData) => localStorage.getItem(key);

// set data
export const setPersistedData = (key: PersistedData, value: string) => localStorage.setItem(key, value);

// remove data
export const removePersistedData = (key: PersistedData) => localStorage.removeItem(key);
